import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { useAuth } from '../../hooks/useAuth'
import { AuthFlowModal } from '../AuthFlow/AuthFlowModal'

const StudioAuthBlocker = () => {
  const { user } = useAuth()
  const [authOpen, setAuthOpen] = useState(!user)

  useEffect(() => {
    if (user && user.twitter_handle && user.twitter_handle.length > 0) setAuthOpen(false)
    else setAuthOpen(true)
  }, [user])

  const handleSuccess = () => {
    setAuthOpen(false)
  }

  const handleClose = () => {
    if (user) setAuthOpen(false)
  }

  return (
    <AuthFlowModal
      open={authOpen}
      onSuccess={handleSuccess}
      hideCloseButton={!user}
      onClickCloseModal={handleClose}
      closeModal={handleClose}
    />
  )
}

export default observer(StudioAuthBlocker)
